import { motion } from "framer-motion"
import { ShieldCheck, BadgeCheck, Activity, Truck } from "lucide-react"

export function TrustBar() {
  const items = [
    { 
      Icon: ShieldCheck, 
      title: "Admin-Mediated Privacy", 
      desc: "Zero unwanted buyer spam" 
    },
    { 
      Icon: BadgeCheck, 
      title: "Verified Sellers Only", 
      desc: "Rigorous GST & factory audit" 
    },
    { 
      Icon: Activity, 
      title: "End-to-End Milestone Escrow", 
      desc: "Guaranteed payment release" 
    },
    { 
      Icon: Truck, 
      title: "Integrated Logistics", 
      desc: "Live Zipaworld tracking" 
    },
  ]

  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    show: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        type: "spring" as const, 
        stiffness: 180, 
        damping: 20 
      } 
    },
  }

  return (
    <section className="bg-surface-container/60 backdrop-blur-sm border-y border-outline-variant/60 py-6 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-30px" }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6"
        >
          {items.map(({ Icon, title, desc }, i) => (
            <motion.div
              key={i}
              variants={itemVariants}
              whileHover={{ y: -3, scale: 1.01 }}
              className="flex items-center gap-3.5 p-3 rounded-xl bg-surface/70 border border-outline-variant/40 hover:border-primary/40 hover:bg-surface transition-all duration-200 shadow-2xs group cursor-default"
            >
              <div className="size-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0 group-hover:bg-primary group-hover:text-white transition-colors duration-200">
                <Icon className="size-5" />
              </div>
              <div className="flex flex-col min-w-0">
                <span className="text-xs font-bold text-on-surface truncate group-hover:text-primary transition-colors">
                  {title}
                </span>
                <span className="text-[11px] text-secondary font-medium truncate">
                  {desc}
                </span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}

